import $ from 'jquery';
import _ from 'underscore';

const sharedClassName = 'projection-grid-popup-plugin';

export const projectionGridPopupPlugin = definePlugin => definePlugin('projectionGridPopup', [
  'config',
  'gridView',
], ({
  plugins: {
    projectionGridPopup,
  },
}, gridView) => {
  const getPopover = container => $(container).find('.popover');
  const closePopover = () => $(`.${sharedClassName}`).remove();

  function getMouseleaveHandler() {
    return function mouseleaveHandler(e) {
      if ($(e.relatedTarget).parents('.popover').length === 1) return;
      closePopover();
    };
  }

  function getMouseenterHandler({
    title,
    content,
    className,
    container,
  }) {
    return function mouseenterHandler(e) {
      e.stopPropagation();
      const key = gridView.keyOfElement(e.target);
      const item = gridView.itemWithKey(key);
      const $target = $(e.target);

      // skip if the popup is triggered by same cell
      const existKey = getPopover(container).attr('data-key');
      if (existKey === key) return;
      closePopover();

      $target.popover({
        html: true,
        trigger: 'manual',
        title: _.isFunction(title) ? title(item) : title,
        content: _.isFunction(content) ? content(item) : content,
        container,
        placement: 'auto right',
        template: `
          <div class="popover ${className} ${sharedClassName}" role="tooltip" data-key="${key}">
            <div class="arrow"></div>
            <h3 class="popover-title"></h3>
            <div class="popover-content"></div>
          </div>`,
      }).popover('show');

      const $popover = getPopover(container);

      $popover.on('mouseleave', () => {
        closePopover();
      });

      $popover.on('click', (ev) => {
        if (ev.target.tagName.toLowerCase() === 'a'
        || ev.target.tagName.toLowerCase() === 'button') {
          return;
        }
        ev.stopPropagation();
      });
    };
  }

  /*
   * popupEvents = {
   *    'mouseenter .selector1, () => {},
   *    'mouseleave .selector2, () => {},
   * }
   */
  const popupEvents = _.reduce(projectionGridPopup, (memo, i) => {
    const option = _.defaults(i, {
      title: '',
      content: '',
      className: '',
      container: 'body',
    });

    const events = _.extend({
      [`mouseenter ${i.selector}`]: _.debounce(getMouseenterHandler(option), 50),
      [`mouseleave ${i.outerSelector}`]: _.debounce(getMouseleaveHandler(option), 50),
    }, memo);
    return events;
  }, {});

  const projectionGridPopupProjection = {
    name: 'projectionGridPopupProjection',
    handler: function scopeNavigator(state) {
      const events = _.defaults({}, popupEvents, state.events);
      return _.defaults({ events }, state);
    },
  };

  gridView.pipeContentProjections(projectionGridPopupProjection);
});
